/*
 * Copyright 2022 (c) Jaguar Land Rover Ltd. All rights reserved.
 */

export const randomID = (length = 12) => {
  // nosemgrep: ajinabraham.njsscan.crypto_node.node_insecure_random_generator
  return (Math.random() * 10 ** length).toFixed();
};
